import { FC } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import dayjs from 'dayjs';
import { ILoadProgressionMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartLegendStyle,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ILoadProgressionMetric | null;
  period?: string;
  height?: number;
}

export const LoadProgressionChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.series || data.series.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <LineChart data={data.series} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis yAxisId="load" orientation="left" tick={chartAxisTick} />
        <YAxis yAxisId="rpe" orientation="right" domain={[0, 10]} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(value, name) => [name === 'load' ? `${value} kg` : value, name === 'load' ? 'Carico (kg)' : 'RPE']}
          labelFormatter={(label) => dayjs(label).format('DD/MM/YYYY')}
        />
        <Legend formatter={(value) => (value === 'load' ? 'Carico (kg)' : 'RPE')} wrapperStyle={chartLegendStyle} />
        <Line
          yAxisId="load"
          type="monotone"
          dataKey="load"
          stroke="var(--c-text-0)"
          strokeWidth={2}
          dot={{ r: 3, fill: 'var(--c-text-0)' }}
        />
        <Line
          yAxisId="rpe"
          type="monotone"
          dataKey="rpe"
          stroke="var(--c-yellow)"
          strokeWidth={2}
          strokeDasharray="4 3"
          dot={{ r: 3, fill: 'var(--c-yellow)' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
